document.addEventListener('DOMContentLoaded', () => {
    const widget = document.getElementById('widgetMaxPopup');
    const closeBtn = document.getElementById('widgetMaxClose');

    if (!widget || !closeBtn) return;

    const DELAY_TO_SHOW_WIDGET = 3000;
    const HOURS_TO_HIDE_WIDGET = 6;

    const storageKey = 'widget_max_closed_until';
    const closedUntil = localStorage.getItem(storageKey);

    if (closedUntil && Date.now() < parseInt(closedUntil, 10)) {
        return;
    }

    setTimeout(() => {
        widget.classList.add('is-initialized');
        widget.classList.add('is-active');
    }, DELAY_TO_SHOW_WIDGET);

    closeBtn.addEventListener('click', (e) => {
        e.preventDefault();

        widget.classList.remove('is-active');

        const expireTimestamp = Date.now() + (HOURS_TO_HIDE_WIDGET * 60 * 60 * 1000);

        localStorage.setItem(storageKey, expireTimestamp);
    });
});